var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-snackbar', {
    key: _vm.snackbar.important,
    "class": {
      clickable: _vm.snackbar.href
    },
    attrs: {
      "timeout": _vm.snackbar.isLoading ? -1 : 1500,
      "show": "",
      "bottom": !_vm.snackbar.important,
      "top": _vm.snackbar.important,
      "color": _vm.snackbar.color,
      "light": _vm.snackbar.light,
      "width": _vm.snackbar.width
    },
    on: {
      "click": function click($event) {
        _vm.goTo();
        _vm.snackbar.show = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_vm.snackbar.isLoading ? _c('v-progress-circular', _vm._b({
          attrs: {
            "indeterminate": "",
            "color": "primary"
          }
        }, 'v-progress-circular', attrs, false)) : _c('v-btn', {
          attrs: {
            "icon": "",
            "color": "error"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              _vm.snackbar.show = false;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": _vm.snackbar.iconColor
          }
        }, [_vm._v(_vm._s(_vm.snackbar.icon ? _vm.snackbar.icon : "mdi-close"))])], 1)];
      }
    }]),
    model: {
      value: _vm.snackbar.show,
      callback: function callback($$v) {
        _vm.$set(_vm.snackbar, "show", $$v);
      },
      expression: "snackbar.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.snackbar.message) + " ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };